import React from 'react';
import HttpClient from 'services/HttpClient';
import { withRouter } from 'react-router-dom';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import ProviderItem from './ProviderItem';
import Pagination from 'blocks/Pagination';
import ProvidersSearch from './ProvidersSearch';
const GET_RESPONCES = '/api/v1/users/?page=';
const PROVIDER_LOGIN = '/api/v1/users/login_for_admin';

@withRouter
@inject('pagination')
@inject('user')
export default class ProvidersList extends React.Component {

  state = {
    users: [],
    searchValue: '',
  };


  componentWillMount = () => {
    this.reguest();
    this.listener = observe(this.props.pagination, 'currentPage', () => this.reguest());
  };


  reguest = () => {
    const {searchValue} = this.state;
    const search = searchValue ? `&query=${searchValue}` : '';
    new HttpClient().get(GET_RESPONCES + this.props.pagination.currentPage + search).then(data => {
      this.setState({users: data.body.data.users});
      this.props.pagination.setTotalPages(data.body.data.pages);
    });
  };

  handleLogin = user_id => {
    new HttpClient().post(PROVIDER_LOGIN, {user_id}).then(data => {
      if(data.status === 200) {
        const {user, token} = data.body.data || {};
        const adminToken = localStorage.getItem('token');
        const adminUser = localStorage.getItem('user');
        localStorage.setItem('adminToken', adminToken);
        localStorage.setItem('adminUser', adminUser);
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        this.props.history.push('/');
        this.props.user.setUser(user);
        console.log(data, adminToken, adminUser);
      }
      // this.setState({users: data.body.data.users});
      // this.props.pagination.setTotalPages(data.body.data.pages);
    });
  }

  handleSearch = search => {
    const searchValue = search ? `&query=${search}` : '';
    new HttpClient().get(GET_RESPONCES + 1 + searchValue).then(data => {
      this.setState({users: data.body.data.users, searchValue: search});
      this.props.pagination.setTotalPages(data.body.data.pages);
    });
  }

  componentWillUnmount = () => {
    this.listener();
    this.props.pagination.setInitialState();
  };

  render(){
    return(<main className="main-content">
      <div className="container-fluid purchased">
        <ProvidersSearch
          handleSearch={this.handleSearch}
        />
        <div className="dashboard row">
          {this.state.users.map(el => <ProviderItem key={el.id} user={el} handleProviderLogin={this.handleLogin} />)}
        </div>
        <Pagination/>

      </div>
    </main>)
  }
}



// WEBPACK FOOTER //
// ./src/components/providersList/ProvidersList.jsx